import Api from './api';

const EducacaoService = {
    listarDocs: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/doceducacao/listar',
            params: params
        })
        return response
    },
    buscarDocs: (params) => {
        const response = Api.get(`/doceducacao/buscar?${params}`)
        return response
    },
    catDocs: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/doceducacao/categorias',
            params: params
        })
        return response
    }
}

export default EducacaoService;